
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import { DashboardYearlyProps } from 'types/props-obj/dashboardYearlyProps';




const initialState: DashboardYearlyProps = {
    apiEndPoint: "line_chart",
    
    data: {'finance':{},'purchase':{},'task':{},'leads':{}},
  
};

const dashboardLineChart = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
       
       

        // GET Items
        setItemsSuccess(state, action) {   
            state.data[action.payload.type][action.payload.frequency] = action.payload.data;
        },

        // ADD Item
      


        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
       
    }
});


export default dashboardLineChart.reducer;

function getApiEndPoint(){
    return store.getState().dashboardLineChart.apiEndPoint
}

export const { setApiEndPoint } = dashboardLineChart.actions;
export function getdashboardLineChartData(params:any={}) {
    return async () => {
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(dashboardLineChart.actions.setItemsSuccess(response.data));
        } catch (error) {
            // dispatch(dashboardLineChart.actions.hasError(error));
        }
    };
}

